// 7.2.2 IsArray(argument)
var cof = require('./_cof');
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/_is-array.js
// module id = 416
// module chunks = 0